import React from 'react';
import PropTypes from 'prop-types';
import { StyledAlert } from './styles';

function UnsupportedViewer({ mimeType }) {
  return (
    <StyledAlert severity="info">
      Перегляд файлів&nbsp;
      {mimeType}
&nbsp;не підтримуються!
    </StyledAlert>
  );
}

UnsupportedViewer.propTypes = {
  mimeType: PropTypes.string.isRequired,
};

export default UnsupportedViewer;
